var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTaskAnimalConfirmation = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M14.158 7.68a.72.72 0 0 1-.718-.718V.96H4.72a.88.88 0 0 0-.88.88v19.84c0 .486.395.88.883.88h14.554a.884.884 0 0 0 .883-.882V7.68zM12 17.28c2.386 0 4.32-2.88 4.32-2.88s-1.934-2.88-4.32-2.88-4.32 2.88-4.32 2.88 1.934 2.88 4.32 2.88m0-.96a1.92 1.92 0 1 0 0-3.84 1.92 1.92 0 0 0 0 3.84m0-.96a.96.96 0 1 0 0-1.919.96.96 0 0 0 0 1.919m8.16-8.64h-5.28a.48.48 0 0 1-.48-.48V.96z",
  clipRule: "evenodd"
})));
export default SvgTaskAnimalConfirmation;